import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const BookingPanel = () => {
    const [BookingData, setBookingData] = useState([]);
    const navigate = useNavigate();

   useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_booking_list"
      );
      setBookingData(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_booking",
        { book_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === 1) {
        setBookingData((prevUser) =>
          prevUser.filter((user) => user.book_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Booking");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Data.");
    }
  };

    return (
        <div className="container mt-5">
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr >
            <th colSpan="7" className=" text-center bg-white fs-4 text-black">Booking Table</th>
          </tr>
          <tr>
            <th className="text-white text-center table-custom">Full Name</th>
            <th className="text-white text-center table-custom">Number</th>
            <th className="text-white text-center table-custom">Room Type</th>
             <th className="text-white text-center table-custom">Room Number</th>
              <th className="text-white text-center table-custom">Check In</th>
               <th className="text-white text-center table-custom">Check Out</th>
            <th className="text-white text-center table-custom">Actions</th>
          </tr>
        </thead>
        <tbody>
          {BookingData.map((Info, index) => (
            <tr key={index}>
               <td className="text-center">{Info.book_name}</td> 
              <td className="text-center"><strong>{Info.book_mobile}</strong></td>
              <td className="text-center"><strong>{Info.room_type}</strong></td>
              <td className="text-center">{Info.room_number}</td> 
              <td className="text-center"><strong>{Info.book_check_in}</strong></td>
              <td className="text-center"><strong>{Info.book_check_out}</strong></td>
              <td className="text-center">
                <button 
                    className="btn btn-danger btn-sm me-1"
                    onClick={() => deleteUser(Info.book_id)}
                  >
                    <i className="fa-regular fa-trash-can text-white"></i>
                  </button>                
              </td>
            </tr>
          ))}
        </tbody>
      </table> 
        </div>    
    );
};